module.exports = __webpack_public_path__ + "static/img/3-he-1-da-zhuan-yun-fa.d342b12.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/3-he-1-da-zhuan-yun-fa.jpeg
// module id = FqY0
// module chunks = 1